import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { PrismCheckbox } from '@mylighthouse/prism-ember';

interface HotelOverviewDashboardSettingsAlertSettingOptInCheckboxSignature {
  Args: {
    checkboxLabel: unknown;
    checkboxValue: unknown;
    hasContentAfterCheckbox: unknown;
    isDisabled: unknown;
    toggleAlertOptIn: unknown;
    valueKey: unknown;
  };
}

const HotelOverviewDashboardSettingsAlertSettingOptInCheckbox = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <PrismCheckbox
    @checked={{@checkboxValue}}
    @disabled={{@isDisabled}}
    @onChange={{fn @toggleAlertOptIn @valueKey}}
  >
    {{@checkboxLabel}}{{#if @hasContentAfterCheckbox}}:{{/if}}
  </PrismCheckbox>
</template> satisfies TOC<HotelOverviewDashboardSettingsAlertSettingOptInCheckboxSignature>;

export default HotelOverviewDashboardSettingsAlertSettingOptInCheckbox;
